var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ServiceResponse } from "../../data/models/service/service-response";
import { RequestOptions, ResponseContentType, Http, Response, Headers } from '@angular/http';
var SSO = /** @class */ (function () {
    function SSO(http) {
        this.http = http;
        this.primaryServiceAddress = serverConfig["serviceAddress"];
        this.buddyServiceAddress = serverConfig["backupServiceAddress"];
    }
    SSO.prototype.getSSOSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, ret, e_1, e_2, _i, _a, p;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        response = null;
                        ret = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 8]);
                        return [4 /*yield*/, this.http.get(this.primaryServiceAddress + "/api/SSOSettings", new RequestOptions({
                                headers: new Headers({ "Content-Type": "application/json" }),
                                responseType: ResponseContentType.Json
                            })).toPromise()];
                    case 2:
                        response = _b.sent();
                        return [3 /*break*/, 8];
                    case 3:
                        e_1 = _b.sent();
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.http.get(this.buddyServiceAddress + "/api/SSOSettings", new RequestOptions({
                                headers: new Headers({ "Content-Type": "application/json" }),
                                responseType: ResponseContentType.Json
                            })).toPromise()];
                    case 5:
                        response = _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _b.sent();
                        throw e_2;
                    case 7: return [3 /*break*/, 8];
                    case 8:
                        if (response && response.json()) {
                            for (_i = 0, _a = response.json(); _i < _a.length; _i++) {
                                p = _a[_i];
                                ret.push(p);
                            }
                            return [2 /*return*/, new ServiceResponse(true, ret)];
                        }
                        else {
                            return [2 /*return*/, new ServiceResponse(false, ret)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return SSO;
}());
export { SSO };



// WEBPACK FOOTER //
// ./src/app/providers/nom-web-services-json/sso.ts.pre-build-optimizer.js